module.exports = __webpack_public_path__ + "img/angola.97a29be0.svg";